// import CanoeSdk from "@csc/canoe-sdk";
import CounponModal from "@/components/CounponModal";
import { HBCommonDialog, HBImageDialog } from "@/components/HBModal/common";

import NPS from "@/components/Nps";
import {
  AdditionGoodDialog,
  BuyVipDialog,
  VipAuthDialog,
} from "@/components/Vip";
import useAppStore from "@/context/store";
import { getCounponByActivity } from "@/services/biz";
import {
  getDeliveryByPosition,
  getDeliveryDetailByModuleId,
} from "@/services/qingzhou";
import { TrackerEvent } from "@/tracker/shared/event";
import { PAGE_CHANGED } from "@/tracker/shared/variable";
import AppEvent, { SimpleEvent } from "@/utils/event";
import { safeParse } from "@/utils/safeParse";
import { match } from "path-to-regexp";
import { globalDialogControl } from "./globalDialog";
// import { OperationPlugin } from '@csc/canoe-sdk/lib';
// 页面与位置的对应关系信息
const allPath = "/:path(.*)";
const positions = {
  "/discovery": ["discovery_dialog", "discovery_nps"],
  "/pins/:pinId": [
    "pin_detail_download_bubble",
    "pin_detail_dialog",
    "pin_detail_nps",
    "vip-persuade-dialog",
    "material_detail_dialog",
  ],
  "/me/right": ["vip_right_dialog", "vip-persuade-dialog"],
  "/search": ["search_dialog", "search_nps"],
  "/materials": ["discovery_material_dialog", "vip-persuade-dialog"],
  "/follow": ["follow_dialog", "follow_nps"],
  "/vip/info": ["vip_info_dialog", "vip-persuade-dialog"],
  "/activities": ["activities_nps"],
  "/board/:id": ["board_detail_nps"],
  "/user/:user": ["user_page_nps"],
  "/ai": ["ai_home_nps"],
  "/me/coupon": ["vip-persuade-dialog"],
  "/topics/:topicId": ["topic_detail_dialog"],
  [allPath]: ["global-dialog"],
};

/**
 * 预置条件
 */
export const PRESETS_CONDITION = {
  // 当前页面停留时长
  CUR_PAGE_STAY_SECONDS: "CUR_PAGE_STAY_SECONDS",
  // 当前页面进入次数
  CUR_PAGE_ENTER_TIMES: "CUR_PAGE_ENTER_TIMES",
  // 花瓣素材转采次数
  HUABAN_MATERIAL_COLLECT_TIMES: "HUABAN_MATERIAL_COLLECT_TIMES",
  // 当日剩余下载次数小于N次
  HUABAN_CUR_DOWNLOAD_BALANCE: "HUABAN_CUR_DOWNLOAD_BALANCE",
  // 花瓣会员到期前N天
  HUABAN_VIP_EXPIRE_BEFORE_DAYS: "HUABAN_VIP_EXPIRE_BEFORE_DAYS",
  // 花瓣会员到期后N天
  HUABAN_VIP_EXPIRE_AFTER_DAYS: "HUABAN_VIP_EXPIRE_AFTER_DAYS",
  // 当日第N次进入会员权益页
  HUABAN_VIP_PAGE_ENTER_TIMES: "HUABAN_VIP_PAGE_ENTER_TIMES",
  // 关闭购买弹窗次数
  TODAY_CLOSE_PAY_DIALOG_TIMES: "TODAY_CLOSE_PAY_DIALOG_TIMES",
  // 进入主站的次数
  CUR_PROJECT_ENTER_TIMES: "CUR_PROJECT_ENTER_TIMES",
  // 素材详情页进入次数
  HUABAN_MATERIAL_DETAILS_ENTER_TIMES: "HUABAN_MATERIAL_DETAILS_ENTER_TIMES",
};

/**
 * Steward意为管家，指代这块功能为管理【这块功能太难取名了】
 * 管的事情:
 * 1、页面变化，自动获取当前页面的配置信息
 * 2、监听触发条件, 响应对应的运营策略
 * 3、条件触发次数记录
 * 4、预置条件触发（页面进入次数，停留时长）
 */
class Steward extends SimpleEvent {
  /**
   * 初始化
   * @param {Array<(data: any)=>void>} actionCbs 触发条件后响应
   */
  constructor(actionCbs) {
    super();
    this.actionCbs = actionCbs;
    this.pageStayTimeouts = [];
  }

  init() {
    if (typeof window === "undefined") {
      return;
    }

    if (this._is_init) {
      return;
    }

    this._is_init = true;

    this.pageInitPromise = this.getPagePositionDelivery();

    TrackerEvent.on(PAGE_CHANGED, () => {
      this.pageInitPromise = this.getPagePositionDelivery();
    });
  }

  /**
   * 获取页面所包含的位置对应的运营配置，即轻舟的投放计划
   */
  async getPagePositionDelivery() {
    const paths = Object.keys(positions);
    const positionDeliveryCache = safeParse(
      sessionStorage.getItem("positionDeliveryCache") || "{}"
    );

    // 取消页面停留时长的条件触发
    if (this.pageStayTimeouts) {
      this.pageStayTimeouts.forEach((time) => {
        clearTimeout(time);
      });
      this.pageStayTimeouts = [];
    }

    // 获取页面对应的位置信息
    for (let i = 0; i < paths.length; i++) {
      const path = paths[i];
      const result = match(path)(window.location.pathname);

      if (!result) continue;
      // 没有缓存
      if (!positionDeliveryCache[path]) {
        const res = await getDeliveryByPosition(
          (path === allPath
            ? positions[path]
            : [...positions[path], ...positions[allPath]]
          ).map((position) => ({
            position,
          }))
        );
        if (res.err) {
          continue;
        }
        positionDeliveryCache[path] = res;
        sessionStorage.setItem(
          "positionDeliveryCache",
          JSON.stringify(positionDeliveryCache)
        );
      }
      // 进入页面初始化条件监听
      this.initConditionListenr(positionDeliveryCache[path], path);

      // 触发进入页面条件
      setTimeout(() => {
        this.trigger(PRESETS_CONDITION.CUR_PAGE_ENTER_TIMES);
      }, 200);

      // 遍历查看是否有条件是 页面停留时长 的配置
      positionDeliveryCache[path].forEach((item) => {
        item.pit_modules.forEach((mod) => {
          if (mod.trigger_type === PRESETS_CONDITION.CUR_PAGE_STAY_SECONDS) {
            this.pageStayTimeouts.push(
              setTimeout(() => {
                this.trigger(PRESETS_CONDITION.CUR_PAGE_STAY_SECONDS, {
                  condition: mod.trigger_condition,
                });
              }, +mod.trigger_condition * 1000 + 200)
            );
          }
        });
      });

      break;
    }
  }

  /**
   * 添加触发条件监听，监听条件，触发响应的组件
   * @param {{
   *  idea_cnt: number,
   *  is_dynamic: 0|1,
   *  pit_name: string,
   *  position: string,
   *  weight_down_flag: boolean,
   *  pit_modules: {
   *    end_time: number,
   *    is_now_pop_up: boolean,
   *    material_type: string,
   *    module_id: number,
   *    module_type: string,
   *    pit_mark: string,
   *    pit_name: string,
   *    plan_id: string,
   *    plan_name: string,
   *    trigger_condition: null|string,
   *    trigger_type: null|string
   *  }[]
   * }[]} mods
   * @param {string} pagePath
   */
  initConditionListenr(mods, pagePath) {
    // 页面切换，重置回调
    this.cb = {};
    mods.forEach(({ pit_modules }) => {
      pit_modules.forEach((el) => {
        if (!el.trigger_type) return;
        this.on(el.trigger_type, async (otherData) => {
          let condition;
          if (
            [
              PRESETS_CONDITION.CUR_PAGE_STAY_SECONDS,
              PRESETS_CONDITION.HUABAN_VIP_EXPIRE_BEFORE_DAYS,
              PRESETS_CONDITION.HUABAN_VIP_EXPIRE_AFTER_DAYS,
              PRESETS_CONDITION.HUABAN_CUR_DOWNLOAD_BALANCE,
            ].includes(el.trigger_type)
          ) {
            // 这类条件的触发数量从触发者（业务页面代码）传递
            condition = otherData?.condition;
          } else {
            // 其他条件则需要前端计数

            condition = this.addConditionTriggerRecord(
              el.trigger_type,
              el.module_id,
              pagePath
            );
          }
          // 是否满足条件
          let isMet = condition == +el.trigger_condition;

          // 一些条件的是否满足是小于设置值
          if (
            [
              PRESETS_CONDITION.HUABAN_CUR_DOWNLOAD_BALANCE,
              PRESETS_CONDITION.HUABAN_VIP_EXPIRE_BEFORE_DAYS,
              PRESETS_CONDITION.HUABAN_VIP_EXPIRE_AFTER_DAYS,
            ].includes(el.trigger_type)
          ) {
            isMet = condition <= +el.trigger_condition;
          }
          // 条件的值是否满足是大于设置值
          if (
            [PRESETS_CONDITION.TODAY_CLOSE_PAY_DIALOG_TIMES].includes(
              el.trigger_type
            )
          ) {
            isMet = condition >= +el.trigger_condition;
          }
          // 数量要求匹配成功，则进行响应

          if (isMet) {
            const getData = () => {
              return getDeliveryDetailByModuleId(
                el.pit_mark,
                el.module_id
              ).then((data) => {
                if (!data || data.message) {
                  return false;
                }

                return data;
              });
            };

            const actionCb =
              this.actionCbs[
                el.material_type === "null" ? el.module_type : el.material_type
              ];

            actionCb &&
              actionCb(getData, {
                otherData,
                // 位置信息
                position: el.pit_mark,
                ...el,
              });
          }
        });
      });
    });
  }

  /**
   * 记录条件触发次数,并返回累计触发次数
   * @param {keyof PRESETS_CONDITION} condition 条件code
   * @param {string|number} module_id id
   * @param {string} pagePath 页面
   * @returns {number}
   */
  addConditionTriggerRecord(condition, module_id, pagePath) {
    let key = condition + "_" + module_id;

    if (condition === PRESETS_CONDITION.CUR_PAGE_ENTER_TIMES) {
      key += "_" + pagePath;
    }

    let record;
    record = safeParse(
      window.localStorage.getItem("hb_qz_condition_record") || "{}",
      () => {
        return {};
      }
    );

    if (record[key]) {
      record[key]++;
    } else {
      record[key] = 1;
    }

    window.localStorage.setItem(
      "hb_qz_condition_record",
      JSON.stringify(record)
    );

    return record[key];
  }

  /**
   * 需要等待初始化才能触发
   * @param {keyof PRESETS_CONDITION} condition
   * @param {{
   *  condition?: number
   * }} otherData
   */
  async trigerAwaitInit(condition, otherData) {
    await this.pageInitPromise;
    this.trigger(condition, otherData);
  }
}

/**
 * 移除条件记录的次数
 * @param {keyof PRESETS_CONDITION} condition 条件code
 * @param {string|number} module_id id
 * @returns {number}
 */
const removeConditionTriggerRecord = (condition, module_id) => {
  let key = condition + "_" + module_id;
  let record = safeParse(
    window.localStorage.getItem("hb_qz_condition_record") || "{}",
    () => {
      return {};
    }
  );
  if (typeof record === "object" && record[key]) {
    delete record[key];
    window.localStorage.setItem(
      "hb_qz_condition_record",
      JSON.stringify(record)
    );
  }
};

// 对应组件响应(相当于回调)
const actionCbs = {
  async global_image_dialog(
    getData,
    { module_name, trigger_type, module_id, otherData, plan_id }
  ) {
    if (useAppStore.getState().isMobile) {
      return;
    }

    const getProps = async () => {
      const data = await getData();
      if (otherData?.needRemoveTrigger) {
        removeConditionTriggerRecord(trigger_type, module_id);
      }
      if (!data || data.message || data.err) {
        return false;
      }
      return {
        ...data,
        module_name,
        module_id,
        plan_id,
        onOk() {
          dialogActionCb(data);
        },
      };
    };

    // 根据模块名称判断优先级
    const isHightPriority = module_name.includes("（优先级高）");

    globalDialogControl.push({
      dialog: HBImageDialog,
      props: getProps,
      priority: isHightPriority ? 0 : 1,
    });
  },
  global_common_dialog(
    getData,
    { module_name, otherData, trigger_type, module_id, plan_id }
  ) {
    if (useAppStore.getState().isMobile) {
      return;
    }

    const getProps = async () => {
      const data = await getData();
      if (otherData?.needRemoveTrigger) {
        removeConditionTriggerRecord(trigger_type, module_id);
      }
      if (!data || data.message || data.err) {
        return false;
      }
      return {
        ...data,
        module_name,
        module_id,
        plan_id,
        onOk() {
          dialogActionCb(data.okButtonProps);
        },
        onCancel() {
          dialogActionCb(data.cancelButtonProps);
        },
      };
    };
    // 根据模块名称判断优先级
    const isHightPriority = module_name.includes("（优先级高）");
    globalDialogControl.push({
      dialog: HBCommonDialog,
      props: getProps,
      priority: isHightPriority ? 0 : 1,
    });
  },
  common_bubble(getData, { position }) {
    AppEvent.trigger(position, getData);
  },

  async NPS(getData, position) {
    if (useAppStore.getState().isMobile) {
      return;
    }

    const getProps = async () => {
      const data = await getData();
      if (!data || data.message || data.msg) {
        return false;
      }
      return {
        data,
        position,
      };
    };
    globalDialogControl.push({
      dialog: NPS,
      props: getProps,
    });
  },
  // 支付挽留弹窗信息
  async dialog_web_retain(
    getData,
    {
      otherData: { checkCondition, onOk, activityCode },
      trigger_type,
      module_id,
    }
  ) {
    removeConditionTriggerRecord(trigger_type, module_id);
    // 检测优惠券状态是否满足条件
    let condition = await checkCondition(activityCode);
    if (!condition) {
      return false;
    }
    const data = await getData();
    // 如果不反回数据则代表不满足频控限制
    if (!data || data.message) {
      return false;
    }
    const res = await getCounponByActivity(
      {
        activity_code: activityCode,
      },
      true
    );
    // 失败处理，失败会直接返回字符串告知失败原因
    if (typeof res === "string" || res instanceof Error) {
      return false;
    }
    // 只要有一张领取成功则展示弹窗
    const isSucceed = res?.some((item) => item.is_success);
    if (res.length && isSucceed) {
      CounponModal.open({
        imgUrl: data.banner_img_url,
        // 倒计时只取第一张券时间
        duration: res[0].coupon?.valid_time?.relative_time_duration,
        onOk() {
          onOk();
        },
      });
    }
  },
  async pay_dialog(getData, { trigger_type, module_id, otherData }) {
    const getProps = async () => {
      const data = await getData();
      if (otherData?.needRemoveTrigger) {
        removeConditionTriggerRecord(trigger_type, module_id);
      }
      if (!data || data.message || data.msg) {
        return false;
      }
      return {
        data,
        "data-source-location": "资源位触发",
      };
    };

    globalDialogControl.push({
      dialog: BuyVipDialog,
      props: getProps,
    });
  },
};

export const stewardInstance = new Steward(actionCbs);

function dialogActionCb(props) {
  switch (props.actionType) {
    // 链接跳转
    case 0:
      window.open(props.href);
      break;
    // 购买弹框
    case 2:
      const { goodType, actionGood } = props;
      const actionsMap = {
        buyVip: BuyVipDialog.open,
        buyVipAuthExtend: VipAuthDialog.open,
        buyAddition: AdditionGoodDialog.open,
      };

      if (actionsMap[goodType]) {
        if (goodType === "buyVip") {
          const [vipType, pkgs = "", versionTab] = actionGood.split("-");

          const [selectedPkg, selectedPlusSku = ""] = pkgs.split("+");

          return BuyVipDialog.open({
            type: vipType,
            selectedPkg: (selectedPkg || "").split(";"),
            defaultSelectPlusSku: selectedPlusSku,
            /**企业会员选中Version（基础授权、高级授权）使用 */
            versionTab,
          });
        }

        actionsMap[goodType]({
          selectedPkg: (actionGood || "").split("-"),
        });
      }
      break;
    default:
      break;
  }
}
